/**
 * @buildautomaton/cli
 *
 * Programmatic exports for the CLI (skills, bridge, ACP client, firehose local proxy helpers).
 * The binary entry is cli.ts (Commander-based).
 */

export { createWsBridge, sendWsMessage } from './connection/create-ws-bridge.js';
export type { CreateWsBridgeOptions } from './connection/create-ws-bridge.js';
export { createAcpClient } from './agents/acp/clients/acp-client.js';
export type { AcpClientOptions, AcpClientHandle, PromptResult } from './agents/acp/clients/acp-client.js';
export { proxyToLocal } from './firehose/proxy/local-proxy.js';
export type { ProxyRequest, ProxyResponse } from './firehose/proxy/local-proxy.js';
export { getSkills, getSkill, callSkill } from './skills/index.js';
export type { Skill, SkillOperation, SkillParam } from './skills/index.js';
export { log, logDebug, logTrace } from './log.js';
export type { LogFn } from './log.js';
export { setCliLogVerbosity, getCliLogVerbosity } from './cli-log-level.js';
export type { CliLogVerbosity } from './cli-log-level.js';
export { runBridge } from './run-bridge.js';
export type { RunBridgeOptions } from './run-bridge.js';
export { openBrowser } from './auth/open-browser.js';
export { runPendingAuth } from './auth/run-pending-auth.js';
export type { AuthResult, RunPendingAuthOptions, PendingAuthHandle } from './auth/run-pending-auth.js';
export { createBridgeConnection } from './connection/create-bridge-connection.js';
export type { CreateBridgeConnectionOptions, BridgeConnectionHandle } from './connection/bridge-connection-types.js';
